export default "__VITE_ASSET__BQ9b_KzX__"